
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"15","viewBox":"0 0 20 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.235 1.968h-8.121L8.496.086A.247.247 0 008.3 0H1.765C.786.01-.001.79 0 1.746v11.51c0 .957.787 1.735 1.765 1.744h16.47c.978-.01 1.765-.787 1.765-1.744V3.712c0-.956-.787-1.734-1.765-1.744z","fill":"#E2E8F0"}})])
          )
        }
      }
    